module.exports = __webpack_public_path__ + "img/product_39.4be38ce.webp";